import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { JobCard } from "./JobsList";
import BlogSidebar from "./BlogSideBar";

// function BlogSidebar() {
//   const [blogs, setBlogs] = useState([]);

//   useEffect(() => {
//     let isMounted = true;
//     const controller = new AbortController();
    
//     axios
//       .get(constvar.api_url + "get_blog_list/6", { signal: controller.signal })
//       .then((res) => {
//         if (!isMounted) return;
//         if (res.data.status === "success") setBlogs(res.data.data || []);
//       })
//       .catch(error => {
//         if (!isMounted) return;
//         if (error.name !== "AbortError" && error.name !== "CanceledError") {
//           console.error("Failed to load blogs:", error);
//         }
//       });

//     // Cleanup: cancel request if component unmounts
//     return () => {
//       isMounted = false;
//       controller.abort();
//     };
//   }, []);

//   return (
//     <div className="sf-sidebar-widget">
//       <div className="sf-widget-header">
//         <h3>Latest Blog</h3>
//         <Link to="/blog">View All</Link>
//       </div>
//       <div className="sf-widget-body">
//         {blogs.length > 0 ? (
//           blogs.map((blog) => (
//             <Link
//               key={blog.id}
//               to={"/blog/" + blog.id}
//               className="sf-blog-item"
//               style={{ textDecoration: "none" }}
//             >
//               <div className="sf-blog-thumb">
//                 <img src={blog.image} alt={blog.title} />
//               </div>
//               <div className="sf-blog-info">
//                 <div className="sf-blog-title">{blog.title}</div>
//                 <div className="sf-blog-date">{blog.created_at}</div>
//               </div>
//             </Link>
//           ))
//         ) : (
//           <p style={{ fontSize: 12, color: "#94a3b8", margin: 0 }}>No blogs yet.</p>
//         )}
//       </div>
//     </div>
//   );
// }

export function LatestJobssss() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    
    axios
      .get(constvar.api_url + "jobs?per_page=12", { signal: controller.signal })

      .then((res) => {
        if (!isMounted) return;
        if (res.data.status === "success") setJobs(res.data.data.data || []);
      })
      .catch(error => {
        if (!isMounted) return;
        if (error.name !== "AbortError" && error.name !== "CanceledError") {
          console.error("Failed to load jobs:", error);
        }
      })
      .finally(() => setLoading(false));

    // Cleanup: cancel request if component unmounts
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  return (
    <section className="sf-section">
      <div className="sf-container">
        <div className="sf-section-header">
          <h2 className="sf-section-title">Latest Jobs</h2>
          <Link to="/job_search" className="sf-section-link">
            View All
          </Link>
        </div>

        <div className="sf-latest-layout">
          <div>
            {loading ? (
              <div className="sf-loading">
                <i className="fa fa-spinner fa-spin" /> Loading…
              </div>
            ) : jobs.length > 0 ? (
              <div className="sf-latest-grid">
                {jobs.map((job) => (
                  <JobCard key={job.id} job={job} />
                ))}
              </div>
            ) : (
              <div className="sf-empty">No latest jobs found.</div>
            )}
          </div>

          <div className="sf-sidebar">
            <BlogSidebar />
          </div>
        </div>
      </div>
    </section>
  );
}


export default function LatestJobs({ title, size, extraParams }) {
  const [employers, setEmployers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedGroup, setExpandedGroup] = useState(null);

  const perPage = size || 12;
  const extra = extraParams || {};

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const params = new URLSearchParams({ per_page: perPage, postDate: "Last 30 Days", ...extra });
    // console.log('🔵 LatestJobs: Fetching jobs from:', constvar.api_url + "jobs/grouped?" + params.toString());
    
    axios
      .get(constvar.api_url + "jobs/grouped?" + params.toString(), {
        signal: controller.signal,
      })
      .then((res) => {
        if (!isMounted) return;
        // console.log('🟢 LatestJobs: API Response:', res.data);
        if (res.data.status === "success") {
          const jobsData = res.data.data.data || [];
          // console.log('🟢 LatestJobs: Setting employers array with', jobsData.length, 'groups');
          setEmployers(jobsData);
        }
      })
      .catch((error) => {
        if (!isMounted) return;
        if (error.name !== "AbortError" && error.name !== "CanceledError") {
          console.error("❌ LatestJobs: Failed to load jobs:", error);
        }
      })
      .finally(() => setLoading(false));

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [perPage, JSON.stringify(extra)]);

  const handleGroupHover = (groupId) => {
    setExpandedGroup(groupId);
  };

  const handleGroupLeave = () => {
    setExpandedGroup(null);
  };

  return (
    <section className="sf-section">
      <div className="sf-container">

        <div className="row">
            <div className="col-xl-9 col-lg-9 col-mg-8 col-sm-12">
                <div className="sf-section-header">
                  <h2 className="sf-section-title">Latest Jobs</h2>
                  <Link to="/job_search" className="sf-section-link">
                    View All
                  </Link>
                </div>

                {loading ? (
                  <div className="sf-loading">
                    <i className="fa fa-spinner fa-spin" /> Loading…
                  </div>
                ) : employers.length > 0 ? (
                  <div className="sf-groupby-employers-grid">
                    {employers.map((employer) => {
                      // Determine if this is an employer or newspaper group
                      const isEmployerGroup = employer.employer_id !== null;
                      const groupId = isEmployerGroup ? employer.employer_id : employer.newspaper_id;
                      const displayName = isEmployerGroup ? employer.comp_name : employer.newspaper_name;
                      const companySlug = isEmployerGroup ? employer.clientslug : null;

                      // console.log('🟡 LatestJobs Group:', { groupId, isEmployerGroup, displayName, comp_name: employer.comp_name, newspaper_name: employer.newspaper_name });

                      const isExpanded = expandedGroup === groupId;
                      const visibleJobs = isExpanded ? employer.jobs.slice(0, 7) : employer.jobs.slice(0, 2);
                      const hasMoreJobs = employer.jobs.length > 2;
                      const remainingCount = employer.jobs.length - 2;

                      return (
                        <div className="jobs_card">
                          <div
                            key={groupId}
                            className={`sf-groupby-employer-card ${isExpanded ? "sf-groupby-employer-card-expanded" : ""}`}
                            onMouseEnter={() => handleGroupHover(groupId)}
                            onMouseLeave={handleGroupLeave}
                          >
                            <div className="flex justify-between">
                              {/* Employer Header */}
                              <div className="sf-groupby-employer-header">
                                <div className="sf-groupby-employer-logo-wrapper">
                                  <img
                                    src={
                                      employer.photo ||
                                      "/default/default_company_logo.jpg"
                                    }
                                    alt={employer.comp_name}
                                    className="sf-groupby-employer-logo"
                                  />
                                </div>
                                <div className="sf-groupby-employer-name">
                                  <h5>
                                    {isEmployerGroup ? (
                                      <Link key={groupId} to={`/company/${companySlug}`} className="sf-groupby-employer-name-link">
                                        {displayName || "N/A"}
                                      </Link>
                                    ) : (
                                      <span className="sf-groupby-employer-name-link">
                                        {displayName || "N/A"}
                                      </span>
                                    )}
                                  </h5>
                                  {visibleJobs.map((job) => (
                                    <Link
                                      key={job.id}
                                      to={"/jobs/" + job.slug}
                                      className="sf-groupby-employer-job-link"
                                    >
                                        {job.job_title.length > 25 
                                          ? `${job.job_title.substring(0, 25)}...` 
                                          : job.job_title
                                        }
                                    </Link>
                                  ))}
                                </div>
                              </div>
                              {/* Expand Button - Show only if more than 2 jobs and is employer group */}
                              {hasMoreJobs && (
                                <div className="sf-groupby-employer-expand-button">
                                  <Link key={groupId} to={`/company/${companySlug}`}>
                                  <span className="sf-groupby-expand-text">
                                  +{remainingCount} more
                                  </span>
                                  <i className="fa fa-chevron-down" />
                                  </Link>
                                </div>
                              )}
                            </div>

                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="sf-empty">No jobs available at the moment.</div>
                )}
            </div>

            <div className="col-xl-3 col-lg-3 col-mg-4 col-sm-12">
                <div className="sf-sidebar">
                  <BlogSidebar />
                </div>
            </div>

        </div>

        
          

      </div>
    </section>
  );
}